import React, {useState} from "react";
import CheckBox from "../CheckBox/CheckBox";
import { useEffect } from "react";

const SingleSiderBarFilterTItleBox = ({
  title,
  label,
  checked,
  setSideBarFilter,
}) => {
  const handleChange = (value) => {
    setSideBarFilter((pre) => ({ ...pre, [label]: value }));
  };
  useEffect(() => {
    setSideBarFilter((pre) => ({ ...pre, [label]: checked }));
  }, []);
  return (
    <div className="flex items-center justify-between ">
      <h2 className="text-[15px] font-semibold leading-[26px]">{title}</h2>
      <CheckBox
        onChange={handleChange}
        setSideBarFilter={setSideBarFilter}
        defaultChecked={checked}
      ></CheckBox>
    </div>
  );
};

export default SingleSiderBarFilterTItleBox;
